<template>
  <div class="cheque-main">
    <div class="left-menu">
      <Menus :menu="menu" @menuClicked="menuClicked" />
    </div>
    <div class="right-container">
      <div class="top-section">
        <div class="filter-description">{{ filterText }}</div>
        <ButtonFilter
          class="button-filter-component"
          filterPosition="right"
          buttonText="Change Filter"
          :filterWidth="300"
          :isOpen.sync="mainFilterIsOpen"
          :buttonIsDisabled="mainFilterIsDisabled"
        >
          <div class="filter-popup">
            <BoxContainer
              title="Date"
              :isCheckBox="true"
              style="margin-bottom: 5px"
              :isChecked.sync="filterDateChequeList"
            >
              <div class="row-display">
                <DateTimePicker
                  :showTime="false"
                  placeholder="From"
                  :isDisabled="!filterDateChequeList"
                  :value.sync="fromChequeListingDate"
                  :errorMessage.sync="fromChequeListingDateErr"
                />
                <DateTimePicker
                  :showTime="false"
                  placeholder="To"
                  :isDisabled="!filterDateChequeList"
                  :value.sync="toChequeListingDate"
                  :errorMessage.sync="toChequeListingDateErr"
                />
              </div>
            </BoxContainer>
            <BoxContainer
              title="Search"
              :isCheckBox="true"
              style="margin-botton: 5px"
              :isChecked.sync="filterSearchChequeList"
            >
              <div>
                <Dropdown
                  ref="searchby"
                  placeholder="Search By"
                  :items="searchFilterItems"
                  itemKey="Search By"
                  :isDisabled="!filterSearchChequeList"
                  :isRequired="filterSearchChequeList"
                  :selectedObject.sync="searchByValue"
                  :errorMessage.sync="searchByErrorMessage"
                />
                <Dropdown
                  ref="searchcriteria"
                  placeholder="Search Criteria"
                  :items="searchCriteriaItems"
                  itemKey="name"
                  :isDisabled="!filterSearchChequeList"
                  :isRequired="filterSearchChequeList"
                  :selectedObject.sync="selectedFilterSearchCriteria"
                  :errorMessage.sync="searchCriteriaErrorMessage"
                />
                <Input
                  ref="search"
                  placeholder="Search"
                  :inputValue.sync="searchInputValue"
                  :isDisabled="!filterSearchChequeList"
                  :isRequired="filterSearchChequeList"
                  :errorMessage.sync="searchInputErrorMessage"
                />
              </div>
            </BoxContainer>
            <button @click="refreshChequeList" :disabled="!filterDateChequeList && !filterSearchChequeList"
              >Refresh
            </button>
          </div>
        </ButtonFilter>
        <div>Last Refreshed: {{ lastRefreshed }}</div>
      </div>
      <div class="bottom-section">
        <TableBox
          title="Cheques"
          :tableData="chequeList"
          :selectedRow.sync="selectedCheque"
          :maxSelection="1"
          :dataType="{ Total: 'currency', Date: 'date' }"
          :hideColumns="['payeeType', 'dateCreate', 'UserCreate', 'BankCode', 'Txn ID']"
        />
      </div>
    </div>
    <PopupEntry
      v-if="popupEntryChequeShow"
      title="Cheque"
      :show.sync="popupEntryChequeShow"
      :viewMode="popupEntryChequeViewMode"
      @save="saveClick()"
      :requiredError="requiredError"
      @requiredClicked="requiredClicked"
      :errorMessages="errorMessage"
      :successMessages="successMessage"
    >
      <div class="new-edit-cheque">
        <div class="top-section">
          <div class="top-section-sub">
            <div class="top-left-section">
              <Dropdown
                placeholder="Cheque Type"
                :isRequired="true"
                :items="chequeTypeList"
                itemKey="type"
                :selectedObject.sync="selectedType"
                @selected="selectedTypeChanged"
                :isDisabled="popupEntryChequeViewMode || typeDisabled"
                :errorMessage.sync="typeError"
                ref="type"
              />
              <Dropdown
                placeholder="Bank"
                :isRequired="true"
                :items="bankList"
                itemKey="BankCode"
                :selectedObject.sync="selectedBank"
                @focusChanged="selectedBankChanged($event)"
                :isDisabled="popupEntryChequeViewMode || !typeDisabled"
                :errorMessage.sync="bankError"
                ref="bank"
              />
              <Input
                :placeholder="chequeNoCaption"
                :inputValue.sync="chequeNoInput"
                :isRequired="true"
                validator="text,25"
                :isDisabled="popupEntryChequeViewMode || chequeNoTypeDisable"
                :errorMessage.sync="chequeNoError"
                ref="chequeno"
              />
              <DateTimePicker
                placeholder="Cheque Date"
                :value.sync="chequeDateInput"
                :isRequired="true"
                :isDisabled="popupEntryChequeViewMode"
                :errorMessage.sync="chequeDateError"
                ref="chequedate"
                @dateChanged="getChequeDateFYear"
              />
              <Input
                placeholder="Payee (Max 100 chars for Chq Printing)"
                :inputValue.sync="payeeInput"
                :isRequired="true"
                validator="text,100"
                :isDisabled="popupEntryChequeViewMode"
              />
            </div>
            <div class="top-mid-right-section">
              <div class="mid-right-top-section">
                <div class="top-mid-section">
                  <div class="top-mid-bank">
                    <div class="bank-text">Bank</div>
                    <Input placeholder="Name" :inputValue.sync="selectedBankName" :isDisabled="true" />
                    <Input placeholder="Balance" :inputValue.sync="selectedBankBalance" :isDisabled="true" />
                  </div>
                </div>
                <div class="top-right-section">
                  <div class="top-right-cheque">
                    <div class="cheque-text">Cheque</div>
                    <Input placeholder="Total Amount" :inputValue.sync="chequeTotal" :isDisabled="true" />
                    <Input placeholder="Total Foreign Amount" :inputValue.sync="chequeFTotal" :isDisabled="true" />
                  </div>
                </div>
              </div>
              <RemarksBox :text.sync="remarksInput" :maxLength="200" :isDisabled="popupEntryChequeViewMode" />
            </div>
          </div>
        </div>
        <div style="height: 100%; margin-top: 5px">
          <Tab :tabs="tabsItems" :tabindex.sync="currentTabIndex" style="height: 100%">
            <div slot="Details" style="height: 100%; width: 100%; display: flex; flex-direction: column">
              <div class="mid-section">
                <div style="display: flex; flex-direction: row; gap: 5px">
                  <button @click="selectPaymentButtonClicked" :disabled="popupEntryChequeViewMode">Add Payment</button>
                  <button @click="deletePaymentButtonClicked" :disabled="popupEntryChequeViewMode"
                    >Delete Payment</button
                  >
                </div>
                <div style="height: calc(100% - 30px)">
                  <TableBox
                    title="Payment"
                    :tableData.sync="chequePaymentList"
                    :selectedRow.sync="selectedChequePayment"
                    :dataType="{
                      'Payment Date': 'date',
                      Amount: 'currency',
                      'F.Amount': 'currency',
                      Rate: 'rate',
                      'Date Update': 'date',
                    }"
                    :hideColumns="['Chq No', 'Commission Amt', 'Txn ID']"
                    :maxSelection="-1"
                    :rowHeight="20"
                    :hideBottomBlock="true"
                    style="flex: 1"
                  />
                </div>
              </div>
              <div class="bottom-section">
                <div class="cheque-posting" :style="mainChequePostingStyling">
                  <div class="cheque-posting-button">
                    <button
                      @click="openAddChequePosting = true"
                      :disabled="popupEntryChequeViewMode || openAddChequePosting"
                      >Add</button
                    >
                    <button @click="deleteChequePosting" :disabled="popupEntryChequeViewMode || openAddChequePosting"
                      >Delete</button
                    >
                    <button @click="chequeGLPostRefresh" :disabled="popupEntryChequeViewMode || openAddChequePosting"
                      >Refresh Cheque Posting</button
                    >
                  </div>
                  <div style="height: calc(100% - 30px)">
                    <TableBox
                      title="Cheque Posting"
                      :tableData="chequeGLPostList"
                      :selectedRow.sync="selectedChequeGLPost"
                      :dataType="{ Amount: 'currency', 'Date Update': 'date', 'Commission Amt': 'currency' }"
                      :hideColumns="['Chq No']"
                      :hideBottomBlock="true"
                      rowHeight="20"
                    />
                  </div>
                </div>
                <div class="info-section">
                  <BoxContainer title="Info">
                    <Input placeholder="Chq Total" :inputValue.sync="chequeTotal" :isDisabled="true" />
                    <Input placeholder="Sub Total" :inputValue.sync="subTotal" :isDisabled="true" />
                    <Input placeholder="GL Balance" :inputValue.sync="glBalance" :isDisabled="true" />
                    <Input placeholder="Total Debit" :inputValue.sync="debitTotal" :isDisabled="true" />
                    <Input placeholder="Total Credit" :inputValue.sync="creditTotal" :isDisabled="true" />
                  </BoxContainer>
                  <!-- <div class="left-info">
                    <Input placeholder="Chq Total" :inputValue.sync="chequeTotal" :isDisabled="true" />
                    <Input placeholder="Sub Total" :inputValue.sync="subTotal" :isDisabled="true" />
                    <Input placeholder="GL Balance" :inputValue.sync="glBalance" :isDisabled="true" />
                    <Input placeholder="Total Debit" :inputValue.sync="debitTotal" :isDisabled="true" />
                    <Input placeholder="Total Credit" :inputValue.sync="creditTotal" :isDisabled="true" />
                  </div> -->
                  <!-- <div class="right-info">
                    <Input placeholder="Total Debit" :inputValue.sync="debitTotal" :isDisabled="true" />
                    <Input placeholder="Total Credit" :inputValue.sync="creditTotal" :isDisabled="true" />
                  </div> -->
                </div>
                <div class="cheque-posting-add" :style="openAddChequePostingStyling">
                  <BoxContainer title="Add Posting" style="height: 95%">
                    <div style="display: flex; justify-content: flex-end; gap: 3px">
                      <button @click="addChequePosting">Add</button>
                      <button @click="cancelChequePosting">Cancel</button>
                    </div>
                    <div style="height: 100%; overflow: scroll">
                      <Dropdown
                        placeholder="Debit Account"
                        :items="glList"
                        itemKey="CodeDesc"
                        :selectedObject.sync="selectedDebitAcc"
                        :errorMessage.sync="selectedDebitAccErrMsg"
                        :isRequired="true"
                      />
                      <Dropdown
                        placeholder="Credit Account"
                        :items="glList"
                        itemKey="CodeDesc"
                        :selectedObject.sync="selectedCreditAcc"
                        :errorMessage.sync="selectedCreditAccErrMsg"
                        :isRequired="true"
                      />
                      <Input
                        placeholder="Amount"
                        :inputValue.sync="cpAmount"
                        validator="positiveCurrency"
                        :errorMessage.sync="cpAmountErrMsg"
                        :isRequired="true"
                        @focusChanged="amountChanges"
                      />
                      <RemarksBox :text.sync="cpRemarks" :maxLength="200" />
                    </div>
                  </BoxContainer>
                </div>
              </div>
            </div>
            <div slot="GL Entry" style="height: 100%; width: 100%; display: flex; flex-direction: column">
              <BoxContainer title="GL Entry" style="height: 100%">
                <div style="height: 100%; display: flex; flex-direction: column">
                  <div>
                    <button @click="refreshChequeGLEntry" :disabled="action == 'N'">Refresh GL</button>
                  </div>
                  <TableBox
                    title=""
                    :rowHeight="20"
                    style="height: 100%"
                    :tableData="chequeGLEntry"
                    :dataType="{ Amount: 'currency' }"
                  />
                </div>
                <div style="display: flex; flex-direction: row; justify-content: space-around; margin-top: 6px">
                  <div style="display: flex; flex-direction: row">
                    <div style="align-self: center; width: 100px">TOTAL DEBIT</div>
                    <div class="total-block">{{ totalDebit }}</div>
                  </div>
                  <div style="display: flex; flex-direction: row">
                    <div style="align-self: center; width: 100px">TOTAL CREDIT</div>
                    <div class="total-block">{{ totalCredit }}</div>
                  </div>
                </div>
              </BoxContainer>
            </div>
          </Tab>
        </div>
      </div>
    </PopupEntry>

    <PopupV2
      type="warning"
      :show="showDeleteChequePopup"
      title="Delete Cheque"
      :buttons="deleteChequePopupButtons"
      @buttonClicked="deleteChequeButtonClicked"
    >
      <div>Are you sure you want to delete cheque ?</div>
      <div
        >Please give your reason why cancel Cheque ({{
          selectedCheque.length > 0 ? selectedCheque[0]['Cheque No'] : ''
        }})</div
      >
      <Input
        placeholder="Remarks"
        :inputValue.sync="cancelChequeRemarks"
        :errorMessage.sync="cancelChequeRemarksError"
        :isRequired="true"
      />
    </PopupV2>
    <PopupV2
      title="Select Payment"
      :show="showSelectPaymentPopup"
      :buttons="selectPaymentPopupButtons"
      @buttonClicked="selectPaymentPopupButtonClicked"
      icon="-"
      width="90%"
      height="90%"
    >
      <div class="select-payment-main">
        <div class="unpaid-pv-list">
          <TableBox
            title="Unpaid Payment List"
            :tableData.sync="paymentList"
            :selectedRow.sync="selectedPayment"
            :hideColumns="['payeeType', 'dateCreate', 'UserCreate', 'BankCode', 'Txn ID']"
            :maxSelection="-1"
            :hideBottomBlock="true"
            rowHeight="20"
            style="height: calc(100% - 30px)"
            :dataType="{
              'Payment Date': 'date',
              Amount: 'currency',
              fAmount: 'currency',
              Rate: 'rate',
              dateCreate: 'datetime',
            }"
          />
          <div style="width: 100%; display: block; margin-top: 3px">
            <button @click="selectPaymentClicked" style="width: 80%">Select</button>
          </div>
        </div>
        <div class="select-pv-list">
          <TableBox
            title="Selected Payment List"
            :tableData.sync="finalSelectedPayment"
            :maxSelection="0"
            :dataType="{ Amount: 'currency', 'Date Update': 'date', 'Commission Amt': 'currency' }"
            :hideColumns="['Chq No', 'Txn ID']"
            :hideBottomBlock="true"
            rowHeight="20"
            style="height: calc(100% - 35px)"
          />
          <div class="select-pv-list-info" style="display: flex; flex-direction: row; gap: 5px">
            <Input placeholder="Total Amount" :inputValue.sync="selectedTotalAmount" :isDisabled="true" />
            <Input placeholder="Currency(Rate)" :inputValue.sync="selectedCurrencyRate" :isDisabled="true" />
            <Input placeholder="Total Payment" :inputValue.sync="finalSelectedPayment.length" :isDisabled="true" />
          </div>
        </div>
      </div>
    </PopupV2>
  </div>
</template>

<script>
export default {
  computed: {
    selectedTotalAmount() {
      return this.finalSelectedPayment.length > 0 ?
          this.finalSelectedPayment
            .map((m) => Number(m['Amount']))
            .reduce((prev, next) => prev + next)
            .toFixed(2)
        : '0.00';
    },
    selectedCurrencyRate() {
      return this.finalSelectedPayment.length > 0 ?
          `${this.finalSelectedPayment[0]['Currency']}(${Number(this.finalSelectedPayment[0]['Rate']).toFixed(4)})`
        : '';
    },
    totalDebit: function () {
      let temp = 0.0;
      if (this.chequeGLEntry.length > 0) {
        this.chequeGLEntry.forEach((gld) => {
          if (gld['Debit Ac'] != '0') {
            temp = parseFloat(temp) + parseFloat(gld['Amount']);
          }
        });
      }
      return this.$currencyFormat(temp);
    },
    totalCredit: function () {
      let temp = 0.0;
      if (this.chequeGLEntry.length > 0) {
        this.chequeGLEntry.forEach((gld) => {
          if (gld['Credit Ac'] != '0') {
            temp = parseFloat(temp) + parseFloat(gld['Amount']);
          }
        });
      }
      return this.$currencyFormat(temp);
    },
    openAddChequePostingStyling: function () {
      return {
        width: this.openAddChequePosting ? '20%' : '0%',
        height: '100%',
        display: this.openAddChequePosting ? 'flex' : 'none',
        flexDirection: 'column',
      };
    },
    mainChequePostingStyling: function () {
      return {
        width: this.openAddChequePosting ? '60%' : '80%',
        display: 'flex',
        flexDirection: 'column',
      };
    },
  },
  data: function () {
    return {
      userDetails: null,
      menu: [
        {
          title: 'New Cheque',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png',
          enabled: false,
          key: 'mnuNew',
        },
        {
          title: 'Edit Cheque',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          enabled: false,
          key: 'mnuEditChq',
        },
        {
          title: 'Delete Cheque',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png',
          enabled: false,
          key: 'mnuDelete',
        },
        {
          title: 'View Cheque',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png',
          enabled: false,
          key: 'mnuPrevChq',
        },
      ],

      currentTabIndex: 0,
      tabsItems: [
        { title: 'Details', disabled: false },
        { title: 'GL Entry', disabled: false },
      ],

      // popupEntryPaymentShow: false,
      popupEntryChequeShow: false,
      popupEntryChequeViewMode: false,

      mainFilterIsOpen: false,
      mainFilterIsDisabled: false,
      // fileNoInput: '',
      filterDateChequeList: true,
      fromChequeListingDate: null,
      toChequeListingDate: null,
      fromChequeListingDateErr: '',
      toChequeListingDateErr: '',
      filterText: '',
      filterSearchChequeList: false,
      searchByValue: '',
      searchByErrorMessage: '',
      searchFilterItems: [{ 'Search By': 'Cheque #', key: 'CH' }],
      searchCriteriaItems: [{ name: 'EQUALS' }, { name: 'STARTS WITH' }, { name: 'CONTAINS' }, { name: 'ENDS WITH' }],
      selectedFilterSearchCriteria: null,
      searchCriteriaErrorMessage: '',
      searchInputValue: '',
      searchInputErrorMessage: '',
      lastRefreshed: '',

      chequeList: [],
      selectedCheque: [],
      paymentList: [],
      selectedPayment: [],
      finalSelectedPayment: [],
      // selectedTotalAmount: '',
      // selectedCurrencyRate: '',

      action: '',
      requiredError: [],
      errorMessage: [],
      successMessage: [],
      chequeTypeList: [
        { type: 'Normal', txntype: 'CH' },
        { type: 'EFT/Debit Advice', txntype: 'TX' },
      ],
      selectedType: null,
      typeError: '',
      typeDisabled: false,
      bankList: [],
      selectedBank: null,
      selectedBankName: '',
      bankError: '',
      selectedBankBalance: '',
      selectedBankGLCode: '',
      chequeTotal: '',
      chequeFTotal: '',
      subTotal: '',
      glBalance: '',
      debitTotal: '',
      creditTotal: '',
      chequeRate: '',
      chequeNoCaption: 'Cheque #',
      chequeNoTypeDisable: false,
      chequeNoInput: '',
      chequeNoInputOri: '',
      chequeNoError: '',
      chequeDateInput: null,
      chequeDateError: '',
      fYear: '',
      oriFYear: '',
      payeeInput: '',
      payeeCodeInput: '',
      payeeType: '',
      remarksInput: '',
      chequeCurrency: '',
      chequePaymentList: [],
      chequePaymentListOri: [],
      selectedChequePayment: [],
      // chequePaymentListError: '',
      chequeGLPostList: [],
      selectedChequeGLPost: [],
      openAddChequePosting: false,
      glList: [],
      selectedDebitAcc: null,
      selectedDebitAccErrMsg: '',
      selectedCreditAcc: null,
      selectedCreditAccErrMsg: '',
      cpAmount: '',
      cpAmountErrMsg: '',
      cpRemarks: '',
      chequeCommissionAmt: '',
      chequeGLEntry: [],

      cancelPVQuestion: '',
      cancelPVDefault: '',
      pvResult: '',
      showDeleteChequePopup: false,
      deleteChequePopupButtons: [
        { text: 'Delete', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'lightgray', textColor: 'black' },
      ],
      showSelectPaymentPopup: false,
      selectPaymentPopupButtons: [
        { text: 'Finish', color: 'green', textColor: 'black' },
        { text: 'Cancel', color: 'lightgray', textColor: 'black' },
      ],
      cancelChequeRemarks: '',
      cancelChequeRemarksError: '',
    };
  },
  props: {},
  methods: {
    async sasControlFunction() {
      this.$fullscreenLoading('Checking Security Access');
      this.menu.forEach((m) => {
        m.enabled = true;
        m.visible = true;
      });
      const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=FINAccount&page=Cheque`);
      sasControl.forEach((k) => {
        //key in menu same as control value from api
        const selectedMenu = this.menu.find((m) => m['key'] == k['Control']);
        if (selectedMenu) {
          selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
        }
      });
      this.$fullscreenLoading();
    },
    async pageChanges() {
      await this.sasControlFunction();
    },
    menuClicked: async function (item) {
      this.clearData();
      switch (item.title) {
        case 'New Cheque':
          this.action = 'N';
          // this.popupEntryPaymentShow = true;
          this.popupEntryChequeViewMode = false;
          this.popupEntryChequeShow = true;
          // this.showSelectPaymentPopup = true;
          await this.selectPaymentButtonClicked();
          // this.refreshUnpaidPVList();
          break;
        case 'Edit Cheque':
          this.action = 'E';
          if (this.selectedCheque.length > 0) {
            const chequeStatus = await this.editDeleteChequeValidation('E');
            if (chequeStatus['editable'] == false) {
              this.$showAlert('error', 'Cannot Edit', chequeStatus['msg']);
              return;
            }
            this.popupEntryChequeViewMode = false;
            await this.getChequeData();
            await this.getChequeGLEntry();
            this.typeDisabled = true;
          } else {
            this.$showAlert('warning', 'No Selected Cheque', 'Please select a cheque to edit.');
            return;
          }
          this.$nextTick(() => (this.popupEntryChequeShow = true));
          break;
        case 'Delete Cheque':
          this.action = 'D';
          if (this.selectedCheque.length > 0) {
            const chequeStatus = await this.editDeleteChequeValidation('D');
            if (chequeStatus['editable'] == false) {
              this.$showAlert('error', 'Cannot Delete', chequeStatus['msg']);
              return;
            }

            // const deleteChequeCheckTemp = await this.$apiCallV2('/Cheque/EditDeleteChequeCheck', { headerid: this.selectedCheque[0]['Txn ID'] });
            // if (deleteChequeCheckTemp) {
            //   if (deleteChequeCheckTemp['status'] == 'P') {
            //     if (deleteChequeCheckTemp['accrole'] != 'A') {
            //       this.$showAlert('error', 'Delete Cheque', `Cannot delete printed Cheque(${this.selectedCheque[0]['Cheque No']})`);
            //       return;
            //     }
            //   }

            //   if (deleteChequeCheckTemp['status'].startsWith('C')) {
            //     this.$showAlert('error', 'Delete Cheque', `Cannot delete cancelled Cheque(${this.selectedCheque[0]['Cheque No']})`);
            //     return;
            //   }

            //   if (deleteChequeCheckTemp['type'] == 'L') {
            //     this.$showAlert('error', 'Delete Cheque', `Cannot delete Cheque. Cheque(${this.selectedCheque[0]['Cheque No']}) have been posted to GL`);
            //     return;
            //   }

            //   if (deleteChequeCheckTemp['isclose'] == '1') {
            //     this.$showAlert('error', 'Delete Cheque', `Cannot delete Cheque. Cheque(${this.selectedCheque[0]['Cheque No']}) reach Month End.`);
            //     return;
            //   }

            //   if (deleteChequeCheckTemp['chqrecon'] == 'S') {
            //     this.$showAlert('error', 'Delete Cheque', `Cannot delete Cheque. Cheque(${this.selectedCheque[0]['Cheque No']}) was Recon in Bank Statement. `);
            //     return;
            //   }
            // } else {
            //   this.$showAlert('error', 'Delete Cheque', 'Cannot delete Cheque. Please check with DSM Support');
            // }

            //start
            const yesNoOption = [{ text: 'No', color: 'gray', textColor: 'white' }, { text: 'Yes' }];
            this.pvResult = '';
            if (this.cancelPVQuestion == 'Y') {
              yesNoOption[0] = yesNoOption.splice(1, 1, yesNoOption[0])[0];
            }

            const cancelPV = await this.$showAlert(
              'warning',
              'Delete Cheque',
              'Do you want to cancel payment voucher as well?',
              yesNoOption,
            );

            if (cancelPV == 'Yes') {
              this.pvResult = 'Y';
            } else {
              this.pvResult = 'N';
            }
            //end

            if (this.pvResult == 'Y') {
              if (chequeStatus['result']['jobtxnrowcount'] == '1') {
                if (chequeStatus['result']['accrole'] != 'A') {
                  //just in case, same checking already above
                  this.pvResult = 'N';
                  this.$showAlert('error', 'Delete Cheque', 'You are not allow to cancel Billed Payment');
                }
                const billDone = await this.$showAlert(
                  'warning',
                  'Billing Done for the PV',
                  'Are you sure you want to cancel Payment?',
                  [{ text: 'No', color: 'gray', textColor: 'white' }, { text: 'Yes' }],
                );
                if (billDone == 'No') {
                  this.pvResult = 'N';
                }
              }
            }

            this.showDeleteChequePopup = true;
          } else {
            this.$showAlert('warning', 'No selected Cheque', 'No selected cheque to delete.');
          }
          break;
        case 'View Cheque': {
          this.action = '';
          if (this.selectedCheque.length > 0) {
            this.popupEntryChequeViewMode = true;
            await this.getChequeData();
            await this.getChequeGLEntry();
            this.typeDisabled = true;
          } else {
            this.$showAlert('warning', 'No Selected Cheque', 'Please select a cheque to view.');
            return;
          }
          this.$nextTick(() => (this.popupEntryChequeShow = true));
        }
      }
    },
    refreshUnpaidPVList: async function () {
      this.$fullscreenLoading('Getting Unpaid PV List...');

      this.paymentList = [];
      this.selectedPayment = [];
      let tempPaymentList = await this.$apiCallV2('/Cheque/GetUnpaidPVList', { paymenttype: 'CH', bankcode: '' });
      if (this.payeeCodeInput != '') {
        tempPaymentList = tempPaymentList.filter((f) => f['Payee Code'] == this.payeeCodeInput);
      }

      if (this.finalSelectedPayment.length > 0) {
        const finalSelectedPaymentNo = this.finalSelectedPayment.map((m) => m['Payment No']);
        tempPaymentList = tempPaymentList.filter((f) => !finalSelectedPaymentNo.includes(f['Payment No']));
      }
      this.paymentList = tempPaymentList;
      this.$fullscreenLoading();
    },
    refreshChequeList: async function () {
      this.$fullscreenLoading('Getting Cheque');
      this.mainFilterIsOpen = false;
      const filterItems = [];
      if (this.filterDateChequeList) {
        filterItems.push(
          `date from ${this.fromChequeListingDate.formatString('yyyy-MM-dd')} to ${this.toChequeListingDate.formatString('yyyy-MM-dd')}`,
        );
      }
      if (this.filterSearchChequeList) {
        filterItems.push(
          `${this.searchByValue['Search By']} ${this.selectedFilterSearchCriteria['name']} ${this.searchInputValue}`,
        );
      }
      this.filterText = `Filter by ${filterItems.join(', ')}`;
      this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm:ss');
      this.chequeList = [];
      this.selectedCheque = [];
      // this.chequeList = await this.$apiCallV2('/Master/GetListMaster', {masterfile: 'CHEQUE'} );
      this.chequeList = await this.$apiCallV2('/Cheque/GetCheque', {
        startdate: this.fromChequeListingDate ? this.fromChequeListingDate.formatString('yyyy-MM-dd') : '',
        enddate: this.toChequeListingDate ? this.toChequeListingDate.formatString('yyyy-MM-dd') : '',
        paymenttype: 'CH',
      });
      this.$fullscreenLoading();
    },
    getChequeData: async function () {
      this.$fullscreenLoading('Getting Cheque Data');
      const chequeData = await this.$apiCallV2('/Cheque/GetChequeDetails', {
        chequetxnid: this.selectedCheque[0]['Txn ID'],
      });
      const cheque = chequeData['ChqTable']['Cheque'][0];
      this.selectedType = this.chequeTypeList.getSelected(cheque['TxnType'], 'txntype');
      this.selectedBank = this.bankList.getSelected(cheque['bank Code'], 'BankCode');
      this.selectedTypeChanged(this.selectedType);
      this.chequeNoInput = cheque['Chq No'] ?? '';
      this.chequeNoInputOri = cheque['Chq No'] ?? '';
      this.chequeDateInput = cheque['Chq Date Issue'] ? cheque['Chq Date Issue'].toDate() : null;
      await this.getChequeDateFYear(this.chequeDateInput);
      this.payeeInput = cheque['Receiver'] ?? '';
      this.payeeCodeInput = cheque['Receiver Code'] ?? '';
      this.payeeType = cheque['Pay For'] ?? '';
      this.remarksInput = cheque['Remark'] ?? '';
      this.chequeCurrency = cheque['Chq Currency'] ?? '';
      this.chequePaymentList = cheque['ChequeDetails'] ?? [];
      this.chequePaymentListOri = cheque['ChequeDetails'] ?? [];
      this.chequeGLPostList = cheque['ChequeGL'] ?? [];
      this.chequeCommissionAmt = cheque['ChequeGL']?.[0]?.['Commission Amt'] ?? '';
      // this.$nextTick();
      await this.selectedBankChanged(false);
      this.chequeTotal = cheque['Chq Total'];
      this.chequeFTotal = cheque['Chq F Total'];
      this.chequeRate = cheque['Chq Rate'];
      this.infoRefresh();
      this.$fullscreenLoading();
    },
    async chequeGLPostRefresh() {
      this.$fullscreenLoading('Getting Cheque GL Posting');
      const result = await this.$apiCallV2('/Cheque/GetRefreshChequeGLPost', {
        fyear: this.fYear,
        pvnoarr: this.chequePaymentList.map((m) => m['Payment No'].trim()).join(','),
      });
      this.chequeGLPostList = [];
      this.$nextTick(() => {
        this.chequeGLPostList = result;
        this.infoRefresh();
      });
      this.$fullscreenLoading();
    },
    async refreshChequeGLEntry() {
      const chequeStatus = await this.editDeleteChequeValidation('R');
      if (chequeStatus['editable'] == false) {
        this.$showAlert('error', 'Cannot Refresh GL', chequeStatus['msg']);
        return;
      }
      this.$fullscreenLoading('Refreshing Cheque GL Entry');
      await this.$apiCallV2('/Cheque/RefreshGL', {
        system: 'FINAccount',
        docno: this.chequeNoInput,
        action: 'E',
        txnid: this.selectedCheque[0]['Txn ID'],
        paymenttype: this.selectedType['txntype'],
      });
      await this.getChequeGLEntry();
      this.$fullscreenLoading('');
    },
    getChequeGLEntry: async function () {
      this.$fullscreenLoading('Getting GL Entry');
      this.chequeGLEntry = [];
      const result = await this.$apiCallV2('/Cheque/GetChequeGLPosting', {
        paymenttype: this.selectedType['txntype'],
        chequetxnid: this.selectedCheque[0]['Txn ID'],
      });
      this.chequeGLEntry = result;
      this.$fullscreenLoading();
    },
    clearData: function () {
      this.action = '';
      this.selectedType = null;
      this.typeDisabled = false;
      this.selectedBank = null;
      this.selectedBankName = '';
      this.selectedBankBalance = '';
      this.chequeTotal = '';
      this.chequeFTotal = '';
      this.subTotal = '';
      this.glBalance = '';
      this.debitTotal = '';
      this.creditTotal = '';
      this.chequeRate = '';
      this.chequeNoInput = '';
      this.chequeNoInputOri = '';
      this.chequeDateInput = null;
      this.payeeInput = '';
      this.payeeCodeInput = '';
      this.payeeType = '';
      this.remarksInput = '';
      this.chequeCurrency = '';
      this.chequePaymentList = [];
      this.chequePaymentListOri = [];
      this.selectedChequePayment = [];
      this.chequeGLPostList = [];
      this.chequeGLEntry = [];
      this.chequeCommissionAmt = '';

      this.pvResult = '';
      this.cancelChequeRemarks = '';
      this.cancelChequeRemarksError = '';
    },
    // nextClick: function() {
    //   console.log('nextClick');
    //   console.log(this.selectedPayment);
    //   if (this.selectedPayment.length > 0) {
    //     console.log(this.selectedPayment);
    //     const tempPayee = this.selectedPayment[0]['PayeeCode'];
    //     const tempCurrency = this.selectedPayment[0]['Currency'];
    //     console.log(tempPayee, tempCurrency);

    //     if (this.selectedPayment.every((e) => e['PayeeCode'] == tempPayee)) {
    //       // do nothing
    //     } else {
    //       this.$showAlert('error', 'Payment Selection', `Cannot select payment with different Payee. Must be same as Payee Code(${tempPayee})`);
    //       return;
    //     }
    //     if (this.selectedPayment.every((e) => e['Currency'] == tempCurrency)) {
    //       //do nothing
    //     } else {
    //       this.$showAlert('error', 'Payment Selection', `Cannot select payment with different currency. Must be same as Currency(${tempCurrency})`);
    //       return;
    //     }

    //     // if (this.selectedPayment.every((e) => e['PayeeCode'] == tempPayee)) {
    //     this.selectedType = this.chequeTypeList.getSelected("CH", "txntype");

    //     this.chequeDateInput = this.selectedPayment[0]['dateissued'].toDate();
    //     this.payeeInput = this.selectedPayment[0]['Payee'];
    //     this.payeeCodeInput = this.selectedPayment[0]['PayeeCode'];
    //     this.payeeType = this.selectedPayment[0]['payeeType'];
    //     this.remarksInput = this.selectedPayment[0]['remark'];
    //     this.chequeCurrency = this.selectedPayment[0]['Currency'];
    //     this.selectedPayment.forEach(e => {
    //       const tempPaymentDate = e['dateissued'].toDate();
    //       if (this.chequeDateInput < tempPaymentDate) {
    //         this.chequeDateInput = tempPaymentDate;
    //       }
    //       this.chequeTotal = Number(this.chequeTotal) + Number(e['Total']);
    //       this.chequeFTotal = Number(this.chequeFTotal) + Number(e['fTotal']);
    //     });
    //     console.log(this.chequeTotal);
    //     console.log(this.chequeFTotal);
    //     // this.chequeTotal = this.selectedPayment[0]['Total'];
    //     // this.chequeFTotal = this.selectedPayment[0]['fTotal'];
    //     if (this.chequeTotal) { this.chequeTotal = Number(this.chequeTotal).toFixed(2); }
    //     if (this.chequeFTotal) { this.chequeFTotal = Number(this.chequeFTotal).toFixed(2); }
    //     this.chequeRate = this.selectedPayment[0]['rate'];
    //     const chequePaymentList = JSON.parse(JSON.stringify(this.selectedPayment));
    //     const formatChequePaymentList = [];
    //     const no = 0;
    //     chequePaymentList.forEach(a => {
    //       formatChequePaymentList.push({
    //         '#': no + 1,
    //         'Payment No': a['PaymentNo'],
    //         'Payment Date': a['dateissued'],
    //         'Job No': a['Job_No'],
    //         'Ref No.': a['Ref_No'],
    //         'Amount': a['Total'],
    //         'F.Amount': a['fTotal'],
    //         'Currency': a['Currency'],
    //         'Rate': a['rate'],
    //         'UserID': a['userid'],
    //         'Date Update': a[''],
    //         'Remark': a['Remark']
    //       });
    //     });
    //     console.log(formatChequePaymentList);

    //     this.chequePaymentList = formatChequePaymentList;
    //     // this.popupEntryPaymentShow = false;
    //     this.popupEntryChequeShow = true;
    //     console.log(this.chequePaymentList);
    //     // } else {
    //     //   this.$showAlert('error', 'Payment Selection', `Cannot select payment with different Payee. Must be same as Payee Code(${tempPayee})`);
    //     //   return;
    //     // }
    //     console.log(this.selectedPayment.every((e) => e['PayeeCode'] == tempPayee)); //every is a method that check all elements in array pass a test
    //   } else {
    //     this.$showAlert('error', 'Payment Selection', 'Must select at least 1 payment');
    //   }
    // },
    selectPaymentClicked: async function () {
      if (this.selectedPayment.length == 0) {
        this.$showAlert('error', 'Payment Selection', 'Must select at least 1 payment');
      }

      const tempPayeeCode = this.payeeCodeInput != '' ? this.payeeCodeInput : this.selectedPayment[0]['Payee Code'];
      const tempPayeeInput = this.payeeInput || this.selectedPayment[0]['Payee Name'];
      const tempCurrency = this.chequeCurrency != '' ? this.chequeCurrency : this.selectedPayment[0]['Currency'];
      const tempPayeeType = this.payeeType || this.selectedPayment[0]['payeeType'];
      if (this.selectedPayment.every((e) => e['Payee Code'] == tempPayeeCode)) {
        // do nothing
      } else {
        this.$showAlert(
          'error',
          'Payment Selection',
          `Cannot select payment with different Payee. Must be same as Payee Code(${tempPayeeCode})`,
        );
        return;
      }

      if (this.selectedPayment.every((e) => e['Currency'] == tempCurrency)) {
        //do nothing
      } else {
        this.$showAlert(
          'error',
          'Payment Selection',
          `Cannot select payment with different currency. Must be same as Currency(${tempCurrency})`,
        );
        return;
      }
      this.$fullscreenLoading('Adding Payment');
      const tempFinalSelectedPayment = JSON.parse(JSON.stringify(this.finalSelectedPayment));
      const tempPaymentList = JSON.parse(JSON.stringify(this.paymentList));
      this.finalSelectedPayment = [];
      this.paymentList = [];
      await this.$nextTick();
      let highestTempNo =
        this.finalSelectedPayment.length > 0 ?
          this.finalSelectedPayment.reduce((max, item) => {
            return Number(item['#']) > max ? Number(item['#']) : max;
          }, 0)
        : 0;
      this.selectedPayment.forEach((f) => {
        highestTempNo++;
        tempFinalSelectedPayment.push({
          '#': highestTempNo,
          'Payment No': f['Payment No'],
          'Payment Date': f['Payment Date'],
          'Job No': f['Job No'],
          'Ref No.': f['Ref No'],
          Amount: f['Amount'],
          'F.Amount': f['fAmount'],
          Currency: f['Currency'],
          Rate: f['Rate'],
          UserID: f['UserID'],
          'Date Update': '',
          Remark: f['Remark'],
          'Chq No': '',
          'Txn ID': '',
        });
      });
      this.finalSelectedPayment = tempFinalSelectedPayment;
      const selectedPaymentNo = this.selectedPayment.map((m) => m['Payment No']);
      this.paymentList = tempPaymentList.filter((f) => !selectedPaymentNo.includes(f['Payment No']));
      this.payeeCodeInput = this.payeeCodeInput || tempPayeeCode;
      this.payeeInput = this.payeeInput || tempPayeeInput;
      this.chequeCurrency = this.chequeCurrency || tempCurrency;
      this.payeeType = this.payeeType || tempPayeeType;
      this.selectedPayment = [];
      this.$nextTick(this.selectedPaymentInfoRefresh());
      this.$fullscreenLoading();
    },
    // finishClicked() {
    //   console.log('finish clicked');
    //   this.chequePaymentList = [];
    //   this.chequePaymentList = JSON.parse(JSON.stringify(this.finalSelectedPayment));
    //   this.showSelectPaymentPopup = false;
    // },
    saveClick: async function () {
      if (this.action == 'N') this.$fullscreenLoading('Saving Cheque');
      else this.$fullscreenLoading('Editing Cheque');

      this.requiredError = [];
      this.errorMessage = [];
      this.successMessage = [];

      if (!this.selectedType) {
        this.requiredError.push({ key: 'type', value: 'Cheque Type is Required!' });
        this.typeError = 'Cheque Type is Required!';
      }
      if (!this.selectedBank) {
        this.requiredError.push({ key: 'bank', value: 'Bank is Required!' });
        this.bankError = 'Bank is Required!';
      }
      if (!this.chequeNoInput) {
        this.requiredError.push({ key: 'chequeno', value: 'Cheque No is Required!' });
        this.chequeNoError = 'Cheque No is Required!';
      }
      if (!this.chequeDateInput) {
        this.requiredError.push({ key: 'chequedate', value: 'Cheque Date is Required!' });
        this.chequeDateError = 'Cheque Date is Required!';
      }
      if (this.chequePaymentList.length < 1) {
        this.requiredError.push({ key: '', value: 'Must have at least 1 payment selected!' });
      }

      const chqTotal = Number(this.chequeTotal) || 0;
      const subTotal = Number(this.subTotal) || 0;
      const debitTotal = Number(this.debitTotal) || 0;
      const creditTotal = Number(this.creditTotal) || 0;

      if (chqTotal !== subTotal) {
        this.requiredError.push({
          key: '',
          value: `Total Credit Amount to Bank GL Code(${this.selectedBankGLCode}) : ${subTotal.toFixed(2)} | Cheque Total : ${chqTotal.toFixed(2)}Not Tally`,
        });
      }

      if (debitTotal !== creditTotal) {
        this.requiredError.push({
          key: '',
          value: `Total Debit Amount (${debitTotal.toFixed(2)}) | Total Credit Amount (${creditTotal.toFixed(2)}) - Not tally`,
        });
      }

      if (this.requiredError.length > 0) {
        this.$fullscreenLoading();
        return;
      }

      if (this.action == 'N' || (this.action == 'E' && this.chequeNoInput != this.chequeNoInputOri)) {
        const checkChqNo = await this.$apiCallV2('/Cheque/CheckChqNo', {
          bankcode: this.selectedBank['BankCode'],
          chequeno: this.chequeNoInput,
        });

        if (checkChqNo[0]['Results'] == 1) {
          const chequeNoContinue = await this.$showAlert(
            'warning',
            checkChqNo[0]['ErrMsg'],
            'Do you want to conitnue using this Cheque no? ',
            [
              { color: 'lightgreen', text: 'Yes' },
              { color: 'lightgrey', text: 'No' },
            ],
          );

          if (chequeNoContinue == 'No') {
            this.$nextTick(() => this.$refs['chequeno'].setFocus());
          }
        }
      }

      const formatSelectedPayment = [];
      this.chequePaymentList.forEach((p) => {
        formatSelectedPayment.push({
          paymentno: p['Payment No'] ?? '',
          paymentdate: new Date(p['Payment Date']).formatString('yyyy-MM-dd') ?? '',
          jobno: p['Job No'] ?? '',
          refno: p['Ref No.'] ?? '',
          amount: p['Amount'] ?? '',
          famount: p['F.Amount'] ?? '',
          remark: p['Remarks'] ?? '',
          currency: p['Currency'] ?? '',
          rate: p['Rate'] ?? '',
          action:
            this.action == 'E' ?
              this.chequePaymentListOri.filter((f) => f['Payment No'] == p['Payment No']).length > 0 ?
                'E'
              : 'N'
            : 'N',
          txnid: p['Txn ID'] ?? '',
        });
      });
      const paymentNoWithTxnId = this.chequePaymentList.filter((f) => f['Txn ID'] != '').map((m) => m['Payment No']);
      const deletePaymentNoList = this.chequePaymentListOri.filter(
        (f) => !paymentNoWithTxnId.includes(f['Payment No']),
      );

      if (deletePaymentNoList.length > 0) {
        deletePaymentNoList.forEach((p) => {
          formatSelectedPayment.push({
            paymentno: p['Payment No'] ?? '',
            paymentdate: new Date(p['Payment Date']).formatString('yyyy-MM-dd') ?? '',
            jobno: p['Job No'] ?? '',
            refno: p['Ref No.'] ?? '',
            amount: p['Amount'] ?? '',
            famount: p['F.Amount'] ?? '',
            remark: p['Remarks'] ?? '',
            currency: p['Currency'] ?? '',
            rate: p['Rate'] ?? '',
            action: 'D',
            txnid: p['Txn ID'] ?? '',
          });
        });
      }

      const saveChequeJSON = {
        paymenttype: this.selectedType['txntype'],
        chequeno: this.chequeNoInput,
        bank: this.selectedBank['BankCode'],
        bankglcode: this.selectedBankGLCode,
        payee: this.payeeCodeInput,
        payeename: this.payeeInput,
        payeetype: this.payeeType,
        remark: this.remarksInput,
        currency: this.chequeCurrency,
        totalamount: this.chequeTotal,
        ftotalamount: this.chequeFTotal,
        rate: this.chequeRate,
        chequedate: this.chequeDateInput.formatString('yyyy-MM-dd'),
        paymentlist: formatSelectedPayment,
        glaccountlist: this.chequeGLPostList,
        autogl: '0',
        action: this.action,
        headerid: this.action == 'E' ? this.selectedCheque[0]['Txn ID'] : '',
        commisionamt: this.chequeCommissionAmt ?? '0.00',
      };

      const saveChequeResult = await this.$apiCallV2('/Cheque/SaveCheque', saveChequeJSON);

      if (saveChequeResult.length > 0) {
        if (saveChequeResult[0]['Results'] == '0') {
          this.successMessage.push('Cheque Save successfully. ');
          await this.refreshChequeList();
        } else {
          this.errorMessage.push(saveChequeResult[0]['ErrMsg']);
        }
      } else {
        this.errorMessage.push('Error saving Cheque. ');
      }

      this.$fullscreenLoading();
    },
    deleteChequeButtonClicked: async function (e) {
      switch (e) {
        case 'Delete': {
          this.$fullscreenLoading('Cancelling Cheque');
          const cancelChequeTemp = await this.$apiCallV2('/Cheque/SaveCheque', {
            headerid: this.selectedCheque[0]['Txn ID'],
            action: 'D',
            cancelreason: this.cancelChequeRemarks,
            pvresult: this.pvResult,
          });
          this.$fullscreenLoading();
          if (cancelChequeTemp[0]['Results'] == '0') {
            await this.refreshChequeList();
            this.$showAlert('success', 'Cheque Cancelled', 'Cheque cancelled successfully');
            this.cancelChequeRemarks = '';
            this.cancelChequeRemarksError = '';
            this.showDeleteChequePopup = false;
          } else {
            this.$showAlert('error', 'Cheque Cancelled', `Cheque cancelled failed. ${cancelChequeTemp[0]['ErrMsg']}`);
          }
          break;
        }
        case 'Cancel':
          this.cancelChequeRemarks = '';
          this.cancelChequeRemarksError = '';
          this.showDeleteChequePopup = false;
          break;
      }
    },
    selectPaymentButtonClicked: async function () {
      this.showSelectPaymentPopup = true;
      this.paymentList = [];
      this.finalSelectedPayment = [];
      await this.$nextTick();
      // this.$nextTick(() => {
      setTimeout(() => {
        this.finalSelectedPayment = JSON.parse(JSON.stringify(this.chequePaymentList));
        this.refreshUnpaidPVList();
        this.selectedPaymentInfoRefresh();
      }, 500); //add settimeout and nexttick so that the popup appear first before the table is populated, otherwise, the table alignment will be off
      // });
    },
    selectPaymentPopupButtonClicked: function (e) {
      if (e === 'Cancel') {
        this.showSelectPaymentPopup = false;
      } else if (e === 'Finish') {
        if (this.finalSelectedPayment.length < 1) {
          this.$showAlert('warning', 'No Select Payment', 'Please select a payment to finish');
          return;
        }
        this.chequePaymentList = [];
        this.$nextTick(async () => {
          this.chequePaymentList = JSON.parse(JSON.stringify(this.finalSelectedPayment));
          this.chequeDateInput = this.finalSelectedPayment[0]['Payment Date'].toDate();
          await this.getChequeDateFYear(this.chequeDateInput);
          this.remarksInput = this.finalSelectedPayment[0]['Remark'];
          this.showSelectPaymentPopup = false;
          this.chequeGLPostRefresh();
        });
      }
    },
    deletePaymentButtonClicked() {
      if (this.selectedChequePayment.length < 1) {
        this.$showAlert('warning', 'No Payment Selected', 'Please select a payment to delete');
        return;
      }

      const tempChequePaymentList = this.chequePaymentList;
      this.chequePaymentList = [];

      this.selectedChequePayment.forEach((c) => {
        const index = tempChequePaymentList.findIndex((f) => f['Payment No'] == c['Payment No']);
        tempChequePaymentList.splice(index, 1);
      });
      this.$nextTick(() => {
        this.chequePaymentList = tempChequePaymentList;
        this.selectedChequePayment = [];
        this.chequeGLPostRefresh();
      });
    },
    selectedTypeChanged: function (val) {
      if (val) {
        if (val['type'] == 'Normal') {
          this.chequeNoCaption = 'Cheque #';
          this.chequeNoTypeDisable = false;
          this.chequeNoInput = '';
        } else {
          this.chequeNoCaption = 'Ref #';
          this.chequeNoTypeDisable = true;
          this.chequeNoInput = '**********';
        }
        this.typeDisabled = true;
      } else {
        this.chequeNoCaption = 'Cheque #';
      }
    },
    selectedBankChanged: async function (state) {
      if (!state) {
        await this.$nextTick();
        if (this.selectedBank) {
          if (this.chequeDateInput) {
            this.$fullscreenLoading('Getting Bank Data');
            const bankbalandChqNo = await this.$apiCallV2('/Cheque/GetBankBalandChqNo', {
              bankcode: this.selectedBank['BankCode'],
              date: this.chequeDateInput ? this.chequeDateInput.formatString('yyyy-MM-dd') : null,
            });
            // if (this.action == 'N' && this.selectedType['txntype'] == 'CH') {
            if (this.action == 'N' && this.selectedType['txntype'] == 'CH') {
              this.chequeNoInput = bankbalandChqNo['Cheque No'];
            }
            this.selectedBankName = this.selectedBank['BankName'];
            this.selectedBankBalance = bankbalandChqNo['Bank Balance'];
            this.selectedBankGLCode = bankbalandChqNo['Acc No'];
            this.$fullscreenLoading();
          } else {
            this.$showAlert(
              'Warning',
              'Cannot retrieve bank details',
              'Cheque Date is required for getting bank balance',
            );
            this.selectedBank = null;
          }
        }
      }
    },
    requiredClicked: function (e) {
      if (this.tabIndex != 0) {
        this.tabIndex = 0;
      }

      this.$nextTick(() => this.$refs[e].setFocus());
    },
    selectedPaymentInfoRefresh: function () {
      this.selectedTotalAmount = this.finalSelectedPayment
        .map((m) => Number(m['Amount']))
        .reduce((prev, next) => prev + next)
        .toFixed(2);
      this.selectedCurrencyRate = `${this.finalSelectedPayment[0]['Currency']}(${this.finalSelectedPayment[0]['Rate']})`;
    },
    infoRefresh: function () {
      let subTotalTemp = 0;
      let debitTotalTemp = 0;
      let creditTotalTemp = 0;

      if (this.chequePaymentList.length > 0) {
        this.chequeTotal = this.chequePaymentList
          .map((m) => Number(m['Amount']))
          .reduce((prev, next) => prev + next)
          .toFixed(2);
        this.chequeFTotal = this.chequePaymentList
          .map((m) => Number(m['F.Amount']))
          .reduce((prev, next) => prev + next)
          .toFixed(2);
      } else {
        this.chequeTotal = '0.00';
        this.chequeFTotal = '0.00';
      }

      if (this.chequeGLPostList.length > 0) {
        this.chequeGLPostList.forEach((f) => {
          if (f['Debit Ac'] == '{BANK}' || f['Debit Ac'] == this.selectedBankGLCode) {
            subTotalTemp = subTotalTemp - Number(f['Amount']);
          }
          if (f['Credit Ac'] == '{BANK}' || f['Credit Ac'] == this.selectedBankGLCode) {
            subTotalTemp = subTotalTemp + Number(f['Amount']);
          }

          if (f['Debit Ac'] != '0') {
            debitTotalTemp = Number(debitTotalTemp) + Number(f['Amount']);
          }
          if (f['Credit Ac'] != '0') {
            creditTotalTemp = Number(creditTotalTemp) + Number(f['Amount']);
          }
        });
      }
      this.subTotal = subTotalTemp.toFixed(2);
      this.glBalance = (Number(this.chequeTotal) - Number(this.subTotal)).toFixed(2);
      this.debitTotal = debitTotalTemp.toFixed(2);
      this.creditTotal = creditTotalTemp.toFixed(2);
    },
    async getChequeDateFYear(newVal) {
      this.$fullscreenLoading('Getting Fyear...');
      if (newVal) {
        const result = await this.$apiCallV2('/FINGLJournal/GetFINGLList', {
          masterfile: 'FYEAR',
          txndate: newVal.formatString('yyyy-MM-dd'),
        });
        this.fYear = result[0]['fyear'];

        await this.getGLList();
      }
      this.$fullscreenLoading();
    },
    async editDeleteChequeValidation(action) {
      //action can be E - edit, D - delete, R - refresh gl
      this.$fullscreenLoading('Checking Cheque Editable');
      let editable = true;
      let msg = '';
      const result = await this.$apiCallV2('/Cheque/EditDeleteChequeCheck', {
        headerid: this.selectedCheque[0]['Txn ID'],
      });
      if (result) {
        if (action == 'D' && result['status'] == 'P' && result['accrole'] != 'A') {
          editable = false;
          msg = `User ${this.userDetails['LoginUserId']} cannot delete printed Cheque. `;
        }
        if (result['status'] == 'C') {
          editable = false;
          msg = 'Cheque already cancelled. ';
        } else if (result['type'] == 'L') {
          editable = false;
          msg = 'Cheque have been posted to GL. ';
        } else if (result['isclose'] == '1') {
          editable = false;
          msg = 'Cheque already close month end. ';
        } else if (action != 'R' && result['chqrecon'] == 'S') {
          //can still refresh GL if already bank recon
          editable = false;
          msg = 'Cheque was recon in bank statement';
        }
      } else {
        (editable = false), (msg = 'Unable to cancel cheque. Please contact DSM support');
      }

      this.$fullscreenLoading('');
      return { editable: editable, msg: msg, result: result };
    },
    async getGLList() {
      this.$fullscreenLoading('Getting GL List');
      if (this.fYear !== this.oriFYear) {
        this.oriFYear = this.fYear;
        this.glList = [];
        const tempGLList = await this.$apiCallV2('/FINGLJournal/GetFINGLList', {
          masterfile: 'GLMASTER',
          fyear: this.fYear,
        });
        if (tempGLList) {
          tempGLList.forEach((f) => {
            f['CodeDesc'] = `${f['Account Code']} - ${f['Account Name'] ?? ''}`;
          });
        }
        this.glList = tempGLList;
      }
      this.$fullscreenLoading('');
    },
    addChequePosting() {
      let check = false;
      if (!this.selectedDebitAcc) {
        this.selectedDebitAccErrMsg = 'Select a Debit Acc';
        check = true;
      }
      if (!this.selectedCreditAcc) {
        this.selectedCreditAccErrMsg = 'Select a Credit Acc';
        check = true;
      }
      if (!this.cpAmount) {
        this.cpAmountErrMsg = 'Enter an amount';
        check = true;
      }
      if (check) {
        return;
      }

      let highestNo =
        this.chequeGLPostList.length > 0 ?
          this.chequeGLPostList.reduce((max, item) => {
            return Number(item['#']) > max ? Number(item['#']) : max;
          }, 0)
        : 0;

      highestNo++;
      const tempChequeGLPostList = JSON.parse(JSON.stringify(this.chequeGLPostList));
      this.chequeGLPostList = [];

      tempChequeGLPostList.push({
        '#': highestNo,
        'Debit Ac': this.selectedDebitAcc['Account Code'],
        'Debit Ac Desc': this.selectedDebitAcc['Account Name'],
        'Credit Ac': this.selectedCreditAcc['Account Code'],
        'Credit Ac De': this.selectedCreditAcc['Account Name'],
        Amount: this.cpAmount,
        'User ID': this.userDetails['LoginUserId'],
        'Date Update': '',
        Remark: this.cpRemarks,
        'Job No': '',
        'Vehicle No': '',
        'Cost Code': '',
        'Chq No': '',
        'Commission Amt': '',
      });
      this.$nextTick(() => {
        this.chequeGLPostList = tempChequeGLPostList;
        this.clearChequeGLPostingFields();
        this.infoRefresh();
      });
    },
    deleteChequePosting() {
      if (this.selectedChequeGLPost.length < 1) {
        this.$showAlert('error', 'No Selected Cheque Posting', 'Please select a cheque posting to delete');
        return;
      }

      const tempChequePosting = this.chequeGLPostList;
      this.chequeGLPostList = [];

      this.selectedChequeGLPost.forEach((c) => {
        const index = tempChequePosting.findIndex((f) => f['#'] == c['#']);
        tempChequePosting.splice(index, 1);
      });
      this.$nextTick(() => {
        this.chequeGLPostList = tempChequePosting;
        this.selectedChequeGLPost = [];
      });
    },
    cancelChequePosting() {
      this.openAddChequePosting = false;
      this.clearChequeGLPostingFields();
    },
    clearChequeGLPostingFields() {
      this.selectedDebitAcc = null;
      this.selectedDebitAccErrMsg = '';
      this.selectedCreditAcc = null;
      this.selectedCreditAccErrMsg = '';
      this.cpAmount = '';
      this.cpAmountErrMsg = '';
      this.cpRemarks = '';
    },
    amountChanges() {
      if (this.cpAmount) {
        this.cpAmount = Number(this.cpAmount).toFixed(2);
      }
    },
  },
  async mounted() {
    const date = new Date();
    this.fromChequeListingDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.toChequeListingDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    await this.refreshChequeList();

    this.bankList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'BANK', module: 'CHQ' });

    const cancelPVQuestionTemp = await this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=CancelPVQuestion');
    if (cancelPVQuestionTemp) {
      this.cancelPVQuestion = cancelPVQuestionTemp[0]['SettingsValue'];
    }
    const cancelPVDefaultTemp = await this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=CancelPVDefault');
    if (cancelPVDefaultTemp) {
      this.cancelPVDefault = cancelPVDefaultTemp[0]['SettingsValue'];
    }

    this.userDetails = await this.$apiCallV2(`/Login/GetDetails`);

    await this.pageChanges();
  },
  watch: {
    async $route() {
      await this.pageChanges();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.cheque-main {
  font-size: 12px;
  padding: 10px 45px;
  width: 100%;
  height: 100%;
  display: flex;

  > .right-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    margin-left: 5px;
    overflow: hidden;

    > * {
      background-color: white;
      padding: 5px;
      border-radius: 5px;
    }

    > .top-section {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;

      > .filter-description {
        padding-right: 8px;
      }

      > .button-filter-component {
        margin-right: 5px;
        position: relative;

        .filter-popup {
          display: flex;
          flex-direction: column;

          > button {
            margin-top: 5px;
            width: fit-content;
            align-self: flex-end;
          }
        }
      }

      > * {
        margin-left: 5px;
      }
    }

    > .bottom-section {
      margin-top: 5px;
      overflow: auto;
      height: 100%;
    }
  }

  .select-payment {
    height: 100%;
    width: 100%;

    > .payment-section {
      display: flex;
      flex-direction: row;

      > :not(:first-child) {
        margin-left: 5px;
      }
    }

    > .table-list-table {
      margin-top: 5px;
      height: calc(100% - 30px);
    }
  }

  .new-edit-cheque {
    height: 100%;
    width: 100%;
    // display: flex;
    // flex-direction: column;
    // overflow-y: auto;
    overflow: scroll;

    > .top-section {
      display: flex;
      flex-direction: column;
      width: 100%;

      > .top-section-sub {
        display: flex;
        flex-direction: row;
        width: 100%;

        > .top-left-section {
          width: 50%;
        }

        > .top-mid-right-section {
          width: 50%;
          display: flex;
          flex-direction: column;

          > .mid-right-top-section {
            display: flex;
            flex-direction: row;
            gap: 5px;

            > .top-mid-section {
              width: 60%;
            }

            > .top-right-section {
              width: 40%;
            }

            > .top-mid-section,
            .top-right-section {
              > .top-mid-bank,
              .top-right-cheque {
                border: 1px solid black;
                border-radius: 5px;
                margin-top: 10px;
                position: relative;

                > .bank-text,
                .cheque-text {
                  top: -10px;
                  position: absolute;
                  background-color: white;
                  padding: 0 10px;
                  left: 10px;
                }

                > :nth-child(2) {
                  margin-top: 10px;
                }
              }
            }
          }
        }

        > :not(:first-child) {
          margin-left: 5px;
        }
      }
    }

    // > .mid-section {
    //   height: 50%;
    //   display: flex;
    //   flex-direction: column;
    // }

    // > .bottom-section {
    //   height: 50%;
    //   display: flex;
    //   flex-direction: row;
    //   width: 100%;
    //   gap: 3px;

    //   > .cheque-posting {
    //     width: 80%;
    //   }

    //   > .info-section {
    //     width: 20%;
    //     // display: flex;
    //     // flex-direction: column;
    //     // gap: 3px;
    //   }
    // }
  }

  .select-payment-main {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    > .unpaid-pv-list {
      height: 55%;
      display: flex;
      flex-direction: column;
    }

    > .select-pv-list {
      height: 45px;
      flex: 1;
      display: flex;
      flex-direction: column;

      > .select-pv-list-info {
        margin-top: 5px;
        display: flex;
        flex-direction: row;
      }
    }
  }

  .mid-section {
    height: 50%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .bottom-section {
    height: 50%;
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 3px;
    flex: 1;

    > .cheque-posting {
      width: 60%;
      display: flex;
      flex-direction: column;

      > .cheque-posting-button {
        display: flex;
        flex-direction: row;
        gap: 5px;
      }
    }

    > .info-section {
      width: 20%;
      // display: flex;
      // flex-direction: column;
      // gap: 3px;
    }

    > .cheque-posting-add {
      width: 20%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
}

.total-block {
  border: 1px solid rgba(128, 128, 128, 0.5);
  max-width: 210px;
  min-width: 210px;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: default;
  padding: 3px;
}
</style>
